import { Component, OnInit, Inject } from '@angular/core';
import { Signatario } from 'src/app/models/signatario';
import { SignatarioService } from 'src/app/services/signatario.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { CadastrarSignatarioModalComponent } from '../cadastrar-signatario-modal/cadastrar-signatario-modal.component';
import swal from 'sweetalert2';

declare const $: any;

@Component({
  selector: 'app-signatarios-modal',
  templateUrl: './signatarios-modal.component.html',
  styleUrls: ['./signatarios-modal.component.scss']
})
export class SignatariosModalComponent implements OnInit {
  signatarios: Signatario[] = [];
  idGIContato: number;

  tipos: any[] = [{ id: 0, nome: 'Representante' }, { id: 1, nome: 'Testemunha' }];

  constructor(
    private signatarioService: SignatarioService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<SignatariosModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.idGIContato = data.idGIContato;
  }

  ngOnInit(): void {
    this.buscarSignatarios();
  }

  buscarSignatarios() {
    this.carregandoService.mostra('buscarSignatarios');
    if(!this.idGIContato) {
      this.signatarioService.consultarListaEmpresaAtual().subscribe(
        (signatarios: Signatario[]) => {
          this.signatarios = signatarios;
          this.carregandoService.esconde('buscarSignatarios');
        },
        (erro) => {
          this.carregandoService.esconde('buscarSignatarios');
          this.notificacaoService.erro('Erro ao buscar signatários.');
        }
      );
    } else {
      this.signatarioService.consultarListaContato(this.idGIContato).subscribe(
        (signatarios: Signatario[]) => {
          this.signatarios = signatarios;
          this.carregandoService.esconde('buscarSignatarios');
        },
        err => {
          this.carregandoService.esconde('buscarSignatarios');
          this.notificacaoService.erro(err);
        }
      );
    }
  }

  novoSignatario() {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(CadastrarSignatarioModalComponent, {
      width: largura > 830 ? '800px' : (($('body').width()).toString() + 'px'),
      data: {
        idGIContato: this.idGIContato,
      },
      panelClass: 'modal-card',
      maxHeight: '90vh'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.buscarSignatarios();
      }
    });
  }

  editarSignatario(sig: Signatario) {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(CadastrarSignatarioModalComponent, {
      width: largura > 830 ? '800px' : (($('body').width()).toString() + 'px'),
      data: {
        idSignatario: sig.idSignatario,
      },
      panelClass: 'modal-card',
      maxHeight: '90vh'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.buscarSignatarios();
      }
    });
  }

  excluirSignatario(sig: Signatario) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir o Signatário?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {

        this.carregandoService.mostra('excluirSignatario');
        this.signatarioService.excluir(sig.idSignatario).subscribe(
          (signatario: Signatario) => {
            this.carregandoService.esconde('excluirSignatario');
            this.buscarSignatarios();
          },
          err => {
            this.carregandoService.esconde('excluirSignatario');
            this.notificacaoService.erro(err);
          }
        );
      }
    });
  }

  fechar() {
    this.dialogRef.close();
  }

  buscarDescricaoTipo(tipo: number) {
    return this.tipos.find(p => tipo == p.id).nome;
  }
}
